import { switchAppUrls } from '../constants/user.constants';

export const isSwitchAppUrl = (url: string): boolean =>
  switchAppUrls.some(switchAppUrl => url.indexOf(switchAppUrl) !== -1);
